import Http from "./http";

export const productListDropdownAPI = (data) => {
    return Http.post("admin/notificationProductList", data);
};
